import { Button, Modal, Collapse } from "antd";

import { validateToken } from "../../../components/Globais";
import { ContainerButton } from "../styles";
const isAdmin = validateToken()?.nda;

const actionButtons = [
  { key: "1", label: "Editar" },
  { key: "2", label: "Excluir" },
];

export default function ModalAcoes({
  isModalOpen,
  handleFechar,
  onClick,
  data,
}: any) {
  const handleButtonClick = (key: string) => {
    const params: any = { key };

    params.interesseId = data.interesseId;
    params.dataIni = data.dataIni;
    params.dataFim = data.dataFim;
    params.status = data.status;
    params.situacao = data.situacao;

    onClick(params);
  };

  return (
    <Modal
      open={isModalOpen}
      onCancel={handleFechar}
      title="Ações Disponíveis"
      footer={null}
    >
      <ContainerButton>
        {actionButtons.map((btn) => (
          <Button
            key={btn.key}
            style={{ margin: "5px 0", width: "100%" }}
            onClick={() => handleButtonClick(btn.key)}
          >
            {btn.label}
          </Button>
        ))}
      </ContainerButton>
    </Modal>
  );
}
